import { DayNumberMapping, StoreOpenTimeAttrDayMapping } from "@/data/constants/clickAndCollect";
import { StoreDetails, StoreFeature } from "@/data/types/Store";
import { findStoreAttributeValueByName } from "@/data/utils/StoreStock";
import { fetchStoreTimeString } from "@/data/utils/storeUtil";
import { fetchSpecialStoreTimings, updateStoreDate } from "./clickAndCollect";

export const getStoreFeature = (store:StoreDetails, currentDay:number, storeEndTimeCutOff:string) => {
    let tempStoreFeture:StoreFeature = {} as StoreFeature;
    let hasSpecialTimes = false;
    let storeClosed = false;
    let storeStartTime, storeEndTime;
    var currentDate = new Date();  // This is moved here so dates have same .getTime() value
    let storeStartDate = new Date();
    let storeEndDate = new Date();
    const storeOpenTimeAttr = StoreOpenTimeAttrDayMapping[currentDay];
    let storeTimings = findStoreAttributeValueByName(store.attributes, storeOpenTimeAttr);
    let storeTImingsSpecial = fetchSpecialStoreTimings(store);
    if(storeTImingsSpecial && storeTImingsSpecial.includes("-") 
        && !storeTImingsSpecial?.toLowerCase().includes("gesloten")){
        storeTimings = storeTImingsSpecial;
        hasSpecialTimes = true;
        tempStoreFeture.storeTimingsSpecial = storeTImingsSpecial;
        tempStoreFeture.hasSpecialTimes=hasSpecialTimes;
    }else {
        storeTImingsSpecial = "";
    }

    if(storeTimings && storeTimings.includes("-")){
        storeStartTime = storeTimings.split("-")[0].trim().replace(":","");
        storeStartDate = updateStoreDate(storeStartTime, storeStartDate);
        storeEndTime = storeTimings.split("-")[1].trim().replace(":","");
        storeStartDate = updateStoreDate(storeEndTime, storeEndDate);
    }else{        
        if(storeTimings.length === 8){
            storeStartTime = storeTimings.substring(0, 4);
            storeStartDate = updateStoreDate(storeStartTime, storeStartDate);
            storeEndTime = storeTimings.substring(4, 8); 
            storeStartDate = updateStoreDate(storeEndTime, storeEndDate);
        }
    }

    if(storeTimings.toLowerCase().includes("gesloten") || storeTimings === '0' || storeTimings === '00002359'){
        storeClosed = true;
    }
//console.log("storeTImingsSpecial is ", storeTImingsSpecial);
    if (storeTImingsSpecial.includes("gesloten")){ 
        storeTImingsSpecial = "";
    }

    
    var localTimeForCurrentDate = currentDate.getTime();
    var localOffsetForCurrentDate = currentDate.getTimezoneOffset() * 60000;
    var utcForCurrentDate = localTimeForCurrentDate + localOffsetForCurrentDate;
    var offsetForCurrentDate = 0; // Have to change after day light savings
    var convertedTimeForCurrentDate = utcForCurrentDate + (3600000 * offsetForCurrentDate);
    var convertedDateTimeForCurrentDate = new Date(convertedTimeForCurrentDate); 
                    
    
    var sameDayDelivery = true;
    let deliveryDay = DayNumberMapping[currentDay];
    if(storeClosed){
        storeTImingsSpecial = fetchSpecialStoreTimings(store, storeClosed)
        storeTimings = fetchStoreTimeString(currentDay+1, store, storeTImingsSpecial ?? "");
        sameDayDelivery = false;
        deliveryDay = DayNumberMapping[currentDay+1];
    }else if( (storeEndDate.getTime() > convertedDateTimeForCurrentDate.getTime()) 
            && ( (storeEndDate.getTime() - convertedDateTimeForCurrentDate.getTime()) <=  (parseInt(storeEndTimeCutOff) * 60000) ) ){
        storeTimings = fetchStoreTimeString(currentDay+1, store, storeTImingsSpecial);
        deliveryDay = DayNumberMapping[currentDay+1];
        sameDayDelivery = false;
    }else if ( (convertedDateTimeForCurrentDate.getTime() > storeEndDate.getTime()) ){
        storeTimings = fetchStoreTimeString(currentDay+1, store, storeTImingsSpecial);
        deliveryDay = DayNumberMapping[currentDay+1];
        sameDayDelivery = false;
    }else if( (storeStartDate.getTime() > convertedDateTimeForCurrentDate.getTime()) ){
        storeTimings = fetchStoreTimeString(currentDay, store, storeTImingsSpecial ?? "");
        sameDayDelivery = true;
    }else if( (storeStartDate.getTime() < convertedDateTimeForCurrentDate.getTime()) ){
        storeTimings = fetchStoreTimeString(currentDay, store, storeTImingsSpecial);
        sameDayDelivery = true;
    }
   
    tempStoreFeture.storeTimings = storeTimings;
    tempStoreFeture.storeClosed = storeClosed;
    tempStoreFeture.sameDayDelivery = sameDayDelivery;
    tempStoreFeture.deliveryDay = deliveryDay;
    return tempStoreFeture;
}